//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
let d=[[[0,"BackgroundOption",1,0],[0,"DeviceHeight",1,0],[0,"DeviceWidth",1,0],[0,"EnhanceEdges",1,0],[0,"FileFormat",1,0],[0,"FileName",1,0],[0,"RegionHeight",1,0],[0,"RegionMode",1,0],[0,"RegionWidth",1,0]],[[["nRegionTopLeftPoint"],"GetRegionTopLeftPoint",{R_:{regionTopLeftPoint:""}},0,0],[["regionTopLeftPoint"],"SetRegionTopLeftPoint",{},1,0],[["nCustomBackgroundColor"],"GetCustomBackgroundColor",{R_:{customBackgroundColor:""}},0,0],[["customBackgroundColor"],"SetCustomBackgroundColor",{},1,0]],[]];
SPLM.Gateway.ImageExportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.ImageExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Gateway.ImageExportBuilder.FileFormats = Object.freeze({
    "Png" : "Png", "Jpg" : "Jpg", "Gif" : "Gif", "Tiff" : "Tiff", "Bmp" : "Bmp", "Xwd" : "Xwd"});

SPLM.Gateway.ImageExportBuilder.BackgroundOptions = Object.freeze({
    "Original" : "Original", "CustomColor" : "CustomColor", "Transparent" : "Transparent"});

export default SPLM;